import React from "react";
import {
  makeStyles,
  Card,
  FormHelperText,
  Grid,
  TextField,
  Typography
} from "@material-ui/core";
import { useFormContext } from "react-hook-form";

const useStyles = makeStyles({
  card: {
    minWidth: "30vw",
    width: "100%"
  },
  title: {
    margin: "20px"
  },
  pos: {
    marginBottom: 12
  },
  input: {
    width: "100%"
  },
  item: {
    width: "100%"
  },
  container: {
    padding: "10px"
  },
  cardContent: {
    marginTop: "20px",
    marginBottom: "20px"
  }
});

const FormDireccion = () => {
  const classes = useStyles();
  const { errors, register } = useFormContext();

  return (
    <Card className={classes.card}>
      <Typography className={classes.title} variant="h5" component="h2">
        Destinatario
      </Typography>
      <Grid container spacing={2} className={classes.container}>
        <Grid item xs={12} sm={12} md={12} className={classes.item}>
          <TextField
            autoComplete="off"
            className={classes.input}
            error={!!errors.nombre}
            inputRef={register({
              required: true
            })}
            label="Nombre y apellido"
            name="nombre"
            variant="outlined"
          />
          {errors.nombre && (
            <FormHelperText error>Este campo es requerido</FormHelperText>
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={12} className={classes.item}>
          <TextField
            autoComplete="off"
            className={classes.input}
            error={!!errors.correo}
            inputRef={register({
              required: true,
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                message: "Correo no válido"
              }
            })}
            label="Correo"
            name="correo"
            variant="outlined"
            type="email"
          />
          {errors.correo && (
            <FormHelperText error>Correo no válido</FormHelperText>
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={6} className={classes.item}>
          <TextField
            autoComplete="off"
            className={classes.input}
            error={!!errors.telefono}
            type="number"
            inputRef={register({
              required: true
            })}
            label="Teléfono"
            name="telefono"
            variant="outlined"
          />
          {errors.telefono && (
            <FormHelperText error>Este campo es requerido</FormHelperText>
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={6} className={classes.item}>
          <TextField
            autoComplete="off"
            className={classes.input}
            error={!!errors.empresa}
            inputRef={register({
              required: false
            })}
            label="Empresa"
            name="empresa"
            variant="outlined"
          />
          {errors.empresa && (
            <FormHelperText error>Este campo es requerido</FormHelperText>
          )}
        </Grid>
      </Grid>
    </Card>
  );
};

export default FormDireccion;
